const link = {
  title: 'Link',
  attributes: {
    title: {},
    uri: { keyboard: 'url', style: 'inline2' },
    image: { type: 'image', keyboard: 'url', style: 'inline2' },
    primary: { type: 'bool', style: 'inline4' },
    accent: { type: 'bool', style: 'inline4' },
    rounded: { type: 'bool', style: 'inline4' },
    color: { style: 'inline4' },
  },
};
const text = { lines: 4 };

export { link, text };

export default {
  id: { required: true, disabled: true, style: 'inline2' },
  language: {
    type: 'select', defaultValue: 'es-ES', dataSource: ['en-EN', 'es-ES'], style: 'inline4',
  },
  title: { required: true, style: 'inline2' },
  url: { keyboard: 'url', required: true, style: 'inline2' },
  description: { ...text },
  logo: { type: 'image' },
  primary: { style: 'inline4' },
  accent: { style: 'inline4' },
  sponsored: { type: 'bool', style: 'inline4' },
  related: {
    type: 'list', label: 'Related stories', dataSource: [], dataSourceField: 'id',
  },
  suggestionBox: {
    title: 'Suggestion Box',
    attributes: {
      title: { required: true },
      image: {
        type: 'image', keyboard: 'url', style: 'inline2',
      },
      backgroundColor: { style: 'inline4' },
      color: { style: 'inline4' },
      pages: { type: 'list' },
      link,
    },
  },
};
